import { enumLanguage } from '../../utils/constant';
import axios from '../axiosInstance';
import { Itimezone } from '../types';

const endpointUserProfile = { ...{ getAdmin: '', upsert: '' } }; // TODO: use real endpoint

const getUserProfile = async (config?: any) => {
  const res = await axios.get<
    never,
    {
      adminPortalId: string;
      id: string | null;
      timezone: Itimezone;
      lang: keyof typeof enumLanguage;
      email: string;
      dateCreated: Date;
      dateLastModified: Date;
    }
  >(endpointUserProfile.getAdmin, config);
  return res;
};

const upsertUserProfile = async (
  params: { lang: keyof typeof enumLanguage; timezone?: string },
  config?: any
) => {
  const input = { ...params, ...config };
  const res = await axios.post<
    never,
    {
      adminPortalId: string;
      id: string | null;
      timezone: Itimezone;
      lang: keyof typeof enumLanguage;
      email: string;
      dateCreated: Date;
      dateLastModified: Date;
    }
  >(endpointUserProfile.upsert, input);
  return res;
};

const apis = { getUserProfile, upsertUserProfile };

export default apis;
